import { render, staticRenderFns } from "./OtaSuccess.vue?vue&type=template&id=306907b3"
import script from "./OtaSuccess.vue?vue&type=script&lang=js"
export * from "./OtaSuccess.vue?vue&type=script&lang=js"
import style0 from "./OtaSuccess.vue?vue&type=style&index=0&id=306907b3&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports